//认证相关接口
import request from '@/utils/request.js'

export default {
    //查询认证内容
    fetch(params){
        return request({
            url: '/api/biz/fetch',
            method: 'GET',
            params
        })
    },
    //查询文章详情
    articleDetail(params){
        return request({
            url: '/api/article/fetch',
            method: 'GET',
            params
        })
    },

    list(params){
        return request({
            url: '/api/biz/list',
            method:'GET',
            params
        })
    }
}